// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import SearchDrawer from '../../../features/globalSearch/SearchDrawer';
import '../../translations';
import { Topbar } from '../Topbar';
import { Stack } from '@mui/material';
import { LoadingScreen } from 'components/fallback/LoadingScreen';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { useState } from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const baseMixin = {
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '100%',
  transition: 'all 500ms ease 0s',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

const desktopMixin = {
  ...baseMixin,
  m: 2,
  mt: 7,
  py: 2,
  px: 4,
};

const mobileMixin = {
  ...baseMixin,
  mt: 7,
  py: 2,
  px: 2,
};

export const MainLayout = () => {
  const [openSideBar, setOpenSideBar] = useState(false);
  const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState(false);
  const { isMobile } = useBreakpoint();

  return (
    <>
      <Topbar toggleSidebar={() => setOpenSideBar(!openSideBar)} openSearchDrawer={setIsSearchDrawerOpen} />
      <SearchDrawer
        data-testid="search-drawer"
        isSearchDrawerOpen={isSearchDrawerOpen}
        setIsSearchDrawerOpen={setIsSearchDrawerOpen}
      />
      <Suspense fallback={<LoadingScreen />}>
        <Stack sx={isMobile ? mobileMixin : desktopMixin} spacing={2}>
          <Outlet context={{ openSideBar, setOpenSideBar }} />
        </Stack>
      </Suspense>
    </>
  );
};
